import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";

// Polling can fail repeatedly. Show each distinct error only once per page
// session, including after the user dismisses it or the toast auto-closes.
const displayedErrors = new Set();

const toastError = err => {
	if (err?.__CANCEL__ || err?.code === "ERR_CANCELED") return;
	const errorMsg = err?.response?.data?.message || err?.response?.data?.error;
	const message = typeof errorMsg === "string" && errorMsg.trim()
		? (i18n.exists(`backendErrors.${errorMsg}`) ? i18n.t(`backendErrors.${errorMsg}`) : errorMsg)
		: "Ocurrió un error. Intentá nuevamente.";
	const toastId = `crm-error:${message}`;
	if (displayedErrors.has(toastId)) return;
	displayedErrors.add(toastId);
	toast.error(message, { toastId });
};

export default toastError;
